import React, { Component } from "react"
import styled from "styled-components"

import { faTimes } from "@jewlr/pro-regular-svg-icons/faTimes"
import FontAwesomeIcon from "components/font-awesome-icon"
import Button from "components/form/button"

const Container = styled.div`
  display: flex;
  padding: 10px;
  margin: ${props => props.margin || "0 0 10px"};
  background-color: ${props => props.theme.colors.grey10};
  border: 1px solid ${props => props.theme.colors.grey65};
  border-radius: 3px;

  ${props =>
    props.type === "error" &&
    `
    color: #721c24;
    background-color: #f8d7da;
    border-color: #f5c6cb;
  `}
  ${props =>
    props.type === "success" &&
    `
    color: #155724;
    background-color: #d4edda;
    border-color: #c3e6cb;
  `}
`
const Content = styled.div`
  flex: 1;
  margin-right: 5px;
`
/**
 * Flashbar
 * @param {string} [message] - Message in flashbar
 * @param {string="success","error"} type - Flashbar type
 */
class Flashbar extends Component {
  constructor(props) {
    super(props)
    this.state = {
      show: true
    }
  }

  handleClose(e) {
    e.preventDefault()
    this.setState({ show: false })
  }

  render() {
    const { children, message, type, margin } = this.props
    const { show } = this.state

    if (!show) return null

    return (
      <Container type={type} margin={margin}>
        <Content>{children ? children : <p>{message}</p>}</Content>
        <Button type="button" text onClick={e => this.handleClose(e)}>
          <FontAwesomeIcon icon={faTimes} />
        </Button>
      </Container>
    )
  }
}

export default Flashbar
